export const types = {
	SET_DEFAULT: 'BILL_TO/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'BILL_TO/SET_ATTRIBUTE_BY_OBJ'
}

const defaultState = {
}

export default (state = defaultState, action) => {
	switch(action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return {type: types.SET_DEFAULT};
	},
	setAttributeByObj: (obj) => {
		return {type: types.SET_ATTRIBUTE_BY_OBJ, obj};
	}
}


// WEBPACK FOOTER //
// ./src/redux/quick-entry/billTo.js